module.exports = __webpack_public_path__ + "img/c05_unitpalintonon_Normal_ua.e5aa1cbf.webp";